import * as types from './actionTypes';

export const setIsMobile = (value: boolean) => ({
    type: types.SET_IS_MOBILE,
    value
});

export default {}; // Typescript yells and won't compile without this...
